import React from "react";
import { toast } from "react-toastify";

const ManualBet = ({
  logoUrl,
  balance,
  chips,
  setChips,
  chipsList,
  handleBet,
  handleSelectChips,
  total,
}) => {
  console.log("chips", chips);
  return (
    <div className="w-full pt-4 lg:pt-6">
      <div className="flex w-full flex-col lg:gap-y-2 gap-y-1.5 items-start">
        <h2 className="text-sm lg:text-base pl-3 lg:pl-5">Choose Chips</h2>
        <div className="w-full border border-[#434343] flex  justify-center sm:justify-between gap-3 sm:gap-0 flex-row items-center bg-[#0d0d0d] rounded-2xl p-4 lg:p-6">
          {chipsList?.map(({ value, url, color }, index) => {
            const isSelected = chips[0]?.value === value;
            return (
              <div
                role="button"
                key={index}
                onClick={() => handleSelectChips(value, url)}
                aria-label="chips"
                className="w-fit"
              >
                <img
                  src={url}
                  alt={`chips ${index + 1}`}
                  style={{
                    borderColor: isSelected ? color : "transparent",
                  }}
                  className={`lg:w-10 w-9  lg:h-10 h-9  transition-all duration-250 ease hover:scale-[1.08] ${
                    isSelected
                      ? "lg:border-2 border rounded-full lg:scale-[1.08] scale-[1.08]"
                      : "opacity-75"
                  }`}
                />
              </div>
            );
          })}
        </div>
        <div className="flex w-full items-center justify-start pl-3 sm:pl-4 gap-x-1">
          <h1 className="text-xs lg:text-[14px] text-[#ebebeb]">
            Balance : <span className="font-semibold">{balance}</span>
          </h1>
          <img className="h-[12px] sm:h-[14px]" src={logoUrl} alt="" />
        </div>
      </div>
      <div className="flex w-full mt-4 lg:mt-5 flex-col lg:gap-y-2 gap-y-1 items-start">
        <h2 className="text-sm lg:text-base pl-3 lg:pl-5">Bet Amount</h2>
        <div className="w-full flex justify-between items-center gap-y-3 sm:gap-y-4 border border-[#434343] bg-[#0d0d0d] rounded-2xl px-4 sm:px-7 py-4 sm:py-5">
          <h1 className="text-sm sm:text-base">{total}</h1>
          {chips?.length !== 0 && (
            <div className="flex w-fit justify-end items-center">
              {chips?.map((item, index) => (
                <img
                  src={item?.url}
                  className={`h-6 sm:h-7 ${
                    index !== 0 ? "-ml-2 sm:-ml-3" : ""
                  }`}
                  key={index}
                  alt={`chips-${index} logo`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <button
        onClick={handleBet}
        className="w-full bg-[#200052] relative hover:top-[1px] transition-all duration-250 ease-in-out active:scale-[0.98] rounded-full text-center py-2 lg:py-3 text-sm lg:text-base mt-3 lg:mt-4 font-medium"
      >
        Place Bet
      </button>
    </div>
  );
};

export default ManualBet;
